<div
  data-at-alert
  class="vi-alert {{ type }} flex flex-row gap-[13px] justify-{{ horizontalFxLayoutAlign }} items-{{
    verticalFxLayoutAlign
  }}"
>
  <mat-icon>{{ icon }}</mat-icon>
  <vi-text><ng-content></ng-content></vi-text>
</div>
